<template>
    <TopNav></TopNav>
		<h1>Pixels to Inches Converter</h1>
		<fieldset>
      <legend>Pixels to Inches Converter</legend>
      <label for="pi">Pixels:</label> <input type="number" v-model.number="pixels" step="any" @input="onPixelChange" autofocus id="pi">
			<br>
      <label for="pp" title="pixels per inch">PPI:</label> <input type="number" v-model.number="ppi" step="any" @input="onPpiChange" id="pp">
      <br>
      <label for="in">Inches:</label> <input type="number" v-model.number="inches" step="any" @input="onInchChange" id="in">
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "PixelsToInches",
  data() {
    return {
      pixels: 96,
      ppi: 96,
      inches: 1,
    }
  },
  components: {
    TopNav
  },
  methods: {
    onPixelChange(e) {
      const pixels = e.currentTarget.value;
      this.inches = pixels / this.ppi;
    },
    onPpiChange(e) {
      const ppi = e.currentTarget.value;
      this.inches = this.pixels / ppi;
    },
    onInchChange(e) {
      const inches = e.currentTarget.value;
      this.pixels = this.ppi * inches;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 90px;
}

footer section a {
  margin: 20px;
}
</style>
